
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/baixe-o-app",
      function () {
        return require("private-next-pages/baixe-o-app.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/baixe-o-app"])
      });
    }
  